<template lang="pug">
  main.bg-white(class='pt-7 md:pt-14')

    section.pb-14.max-w-4xl.mx-auto(class='px-4 md:px-0')
      .prose-content.max-w-prose.mx-auto.mb-6
        h1 Resources
        p Here's a collection of useful resources and tools for text generation.
      div(class='max-w-prose mx-auto space-y-2 sm:space-y-0 sm:grid sm:grid-cols-2 sm:gap-4')
        div(
          v-for='item in items'
          :key='item.name'
          class='pb-2 border-b-2 border-gray-50 last:border-0 sm:border-0 sm:pb-0'
        )
          h2(class='text-xl font-bold')
            a(class='text-blue-600 hover:underline' :href='item.url' target='_blank' rel='nofollow noopener') {{ item.name }}
          p {{ item.descr }}

</template>

<script>

export default {
  name: 'Resources',

  metaInfo: {
    // title will be injected into parent titleTemplate
    title: 'Resources'
  },

  data () {
    return {
      items: [
        {
          name: 'Corpora',
          descr: 'A collection of corpora for the creation of bots and similar things by Darius Kazemi and others (English, files in JSON-format)',
          url: 'https://github.com/dariusk/corpora'
        },
        {
          name: 'Textstelle',
          descr: 'Another collection of corpora in German and English language. Mostly *.txt files.',
          url: 'https://textstelle.0x0a.li'
        },
        {
          name: 'Wikipedia lists',
          descr: 'Wikipedia is a great resource for lists of things. It seems like there is a list for everything!',
          url: 'https://en.wikipedia.org/wiki/Category:Lists'
        },
        {
          name: 'Wiktionary',
          descr: 'Wiktionary has words organized into categories. And there are many of them (not only in the English Wiktionary)!',
          url: 'https://en.wiktionary.org/wiki/Special:Categories'
        },
        {
          name: 'Wordnik',
          descr: 'Wordnik described itself as "the world\'s biggest online English dictionary, by number of words". It has a large community and more than 30,000 lists of words.',
          url: 'https://www.wordnik.com'
        },
        {
          name: 'Copytables',
          descr: 'A browser extension to extract content of tables (useful for Wikipedia lists in table format).',
          url: 'https://merribithouse.net/copytables'
        },
        {
          name: 'Tracery',
          descr: 'Tracery is a JavaScript library to generate text. Plauder is inspired by Tracery.',
          url: 'http://tracery.io'
        }
      ]
    }
  }

}
</script>
